import React, { useEffect, useState } from "react"
import Select from "react-select"

import MetaTags from "react-meta-tags"
import { map } from "lodash"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  InputGroup,
  CardTitle,
} from "reactstrap"
import classnames from "classnames"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"

//Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import ZeroDeoposit from "./TabOne"
import OneDeposit from "./TabTwo"
import OneBet from "./OneBet.js/OneBet"
import {sitename} from "../../constants/constants";
import TabOne from "./TabOne";
import TabTwo from "./TabTwo";
import TabThree from "./TabThree";
import TabFour from "./TabFour";
import TabFive from "./TabFive";
import TabSix from "./TabSix"

const EndUsers = props => {
  const [startDate, setStartDate] = useState(new Date())
  const [activeTab, setActiveTab] = useState("1")

  const handleChange = date => {
    setStartDate(date)
  }

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Risk Per User" />

          <Row>
            <Col lg="12">
              {/* <Card>
                <CardBody> */}
              <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "1",
                    })}
                    style={{ backgroundColor: "#F8F8FB" }}
                    onClick={() => {
                      toggleTab("1")
                    }}
                  >
                    {"Non Depositors "}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "2",
                    })}
                    style={{ backgroundColor: "#F8F8FB" }}
                    onClick={() => {
                      toggleTab("2")
                    }}
                  >
                    {"Regulars "}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "3",
                    })}
                    onClick={() => {
                      toggleTab("3")
                    }}
                    style={{ backgroundColor: "#F8F8FB" }}
                  >
                    {"Regulars"}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "4",
                    })}
                    onClick={() => {
                      toggleTab("4")
                    }}
                    style={{ backgroundColor: "#F8F8FB" }}
                  >
                    {"ViP's"}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "5",
                    })}
                    onClick={() => {
                      toggleTab("5")
                    }}
                    style={{ backgroundColor: "#F8F8FB" }}
                  >
                    {"Dormant"}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "6",
                    })}
                    onClick={() => {
                      toggleTab("6")
                    }}
                    style={{ backgroundColor: "#F8F8FB" }}
                  >
                    {"Last Played"}
                  </NavLink>
                </NavItem>
              </ul>

              <TabContent activeTab={activeTab} className="p-3">
                <TabPane tabId="1" id="dashboard">
                  <Row>
                    <TabOne />
                  </Row>
                </TabPane>
                <TabPane tabId="2" id="performance">
                  <Row>
                    <TabTwo />
                  </Row>
                </TabPane>
                <TabPane tabId="3" id="transactions">
                  <TabThree />
                </TabPane>
                <TabPane tabId="4" id="transactions">
                  <TabFour />
                </TabPane>
                <TabPane tabId="5" id="transactions">
                  <TabFive />
                </TabPane>
                <TabPane tabId="6" id="transactions">
                  <TabSix />
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(EndUsers)
